
import React, { useState } from 'react';
import { Card, CardTitle, CardDescription, CardContent } from "../../components/ui/card";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "../../components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "../../components/ui/popover";
import { Button } from "../../components/ui/button";
import { Check, ChevronsUpDown, Database } from 'lucide-react';
import { cn } from "../../lib/utils";
import PreferenceItem from "./PreferenceItem";
import SectionHeader from "./SectionHeader";

const MARKETPLACE_FORMATS = [
  { value: 'amazon', label: 'Amazon', available: true },
  { value: 'trendyol', label: 'Trendyol', available: true },
  { value: 'hepsiburada', label: 'Hepsiburada', available: true },
  { value: 'ebay', label: 'eBay', available: false },
  { value: 'etsy', label: 'Etsy', available: false },
  { value: 'temu', label: 'Temu', available: false }
];

const FormatFeature = ({
  selectedFormat,
  onFormatChange,
  errors = []
}) => {
  const [isFormatPopoverOpen, setIsFormatPopoverOpen] = useState(false);

  return (
    <Card>
      <CardContent className="space-y-6 pt-6">
        <SectionHeader
          icon={Database}
          title="Marketplace Format"
          description="Select marketplace for content format"
        />

        <PreferenceItem
          label="Format"
          tooltip="Select the marketplace format for your product content"
          fieldName="general.format"
          errors={errors}
        >
          <Popover open={isFormatPopoverOpen} onOpenChange={setIsFormatPopoverOpen}>
            <PopoverTrigger asChild>
              <Button
                variant="outline"
                role="combobox"
                className="w-full justify-between"
              >
                {selectedFormat
                  ? MARKETPLACE_FORMATS.find((f) => f.value === selectedFormat)?.label
                  : "Select format..."}
                <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
              </Button>
            </PopoverTrigger>
            <PopoverContent className="w-full p-0">
              <Command>
                <CommandInput placeholder="Search format..." />
                <CommandEmpty>No format found.</CommandEmpty>
                <CommandList>
                  <CommandGroup>
                    {MARKETPLACE_FORMATS.map((format) => (
                      <CommandItem
                        key={format.value}
                        value={format.value}
                        onSelect={(currentValue) => {
                          onFormatChange(currentValue);
                          setIsFormatPopoverOpen(false);
                        }}
                        disabled={!format.available}
                      >
                        <Check
                          className={cn(
                            "mr-2 h-4 w-4",
                            selectedFormat === format.value ? "opacity-100" : "opacity-0"
                          )}
                        />
                        {format.label}
                        {!format.available && (
                          <span className="ml-auto text-xs text-muted-foreground">(Coming soon)</span>
                        )}
                      </CommandItem>
                    ))}
                  </CommandGroup>
                </CommandList>
              </Command>
            </PopoverContent>
          </Popover>
        </PreferenceItem>
      </CardContent>
    </Card>
  );
};

export default FormatFeature;